import React, { useState } from 'react'
import LandingWrapper from './LandingWrapper'
import { BsCheckCircleFill } from 'react-icons/bs'
import { SiFastapi } from 'react-icons/si'
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';
import './styles.css'

export default function LandingApi() {
    return (
        <LandingWrapper>
            <HeaderApi />
            <DescriptionApi />
            <StrongPoint />
            <Fast />
            <Process />
            <Cachet />
            <HowUseElectronik />
            <WeClient />
        </LandingWrapper>
    )
}

const HeaderApi = () => {
    return (
        <div className="landing_api-content">

            <Fade duration={4000} left>
                <img className='landing_api-image' src="./assets/media/home_icon/image_api.png" alt="image_api" />
            </Fade>

            <div className="landing_api_title">
                L'API DE DKBSIGN A VOTRE SERVICE
            </div>


            <Fade duration={4000} right>
                <div className="request-demo-btn">DEMANDER UNE DEMO</div>
            </Fade>
        </div>
    )
}

// <Fade duration={4000} left></Fade>
const DescriptionApi = () => {
    return (
        <div className="landing_api-description">
            <Fade duration={4000} left>
                <p>
                    Le réseau DKB Sign permet aux entreprises de tout type et de toute taille de conclure des affaires plus rapidement à tout moment, en tout lieu et sur tous les appareils grâce à la solution de signature électronique la plus utilisée en Côte d'Ivoire.
                </p>
            </Fade>
        </div>
    )
}

const StrongPoint = () => {
    return (
        <div className="landing_api-strongpoint">
            <Fade duration={4000} left>
                <div className="landing_api-strongpoint-title">Nos points forts API</div>
            </Fade>
            <hr className='line-strong-point' />
            <div className="display-strongpoint">
                <Zoom top duration={3000}>
                    <img className='strongpoint-img' src="./assets/media/home_icon/innovation.png" alt="Innovation" />
                    <img className='strongpoint-img' src="./assets/media/home_icon/rapide.png" alt="Innovation" />
                    <img className='strongpoint-img' src="./assets/media/home_icon/ecolo.png" alt="Innovation" />
                    <img className='strongpoint-img' src="./assets/media/home_icon/securise.png" alt="Innovation" />
                </Zoom>
            </div>
        </div>
    )
}

const HowUseElectronik = () => {
    const [useData] = useState([
        {
            id: 2,
            logo: <SiFastapi size={30} color={'#164A80'} className='landing_api-how-use-item-logo' />,
            title: 'Via l’API DKB Sign',
            description: 'Directement intégrée à votre site web ou logiciel métier, signez automatiquement tous vos documents.'
        }
    ])
    return (
        <div className="landing_api-how-use">
            <Fade duration={4000} left>
                <div className="landing_api-how-use-left">
                    <div className="landing_api-how-use-title">Comment utiliser la signature electronique ?</div>

                    <div className="landing_api-how-use-content">
                        {useData.map((item) => (
                            <HowUseElectronikItem key={item.id} {...item} />
                        ))}
                    </div>
                </div>
            </Fade>

            <Fade duration={4000} right>
                <div className="landing_api-how-use-right">
                    <img className='use-right-img' src="./assets/media/home_icon/how_use.png" alt="img-use-right" />
                </div>
            </Fade>
        </div>
    )
}

const HowUseElectronikItem = ({ logo, title, description }) => {
    return (
        <div className="landing_api-how-use-item">
            {logo}
            <div className="landing_api-how-use-item-content">
                <div className="landing_api-how-use-item-title">{title}</div>
                <div className="landing_api-how-use-item-description">{description}</div>
            </div>
        </div>
    )
}

const Integration = () => {
    return (
        <React.Fragment>
            <div className="landing-tarif__faq-content">
                <div className="landing-tarif__faq-header">
                    <p className='landing_api-garantir'>GARANTISSEZ LA REGLEMENTATION DE VOS TRANSACTIONS NUMERIQUE</p>
                </div>
            </div>
        </React.Fragment>
    )
}

const WePlus = () => {
    return (
        <div className="landing_api-weplus">
            <div className="landing_api-weplus-title">
                <div className='landing_api-weplus-txt'>Nos</div>
                <div className='landing_api-weplus-plus'>+</div>
                <div className='landing_api-weplus-txt'>que nous vous apporterons</div>
            </div>
        </div>
    )
}

const WeClient = () => {
    const [images] = useState([
        {
            id: 1,
            src: './assets/media/home_icon/ent_1.png',
            alt: 'image_entreprise'
        },
        {
            id: 2,
            src: './assets/media/home_icon/ent_2.png',
            alt: 'image_entreprise'
        },
        {
            id: 3,
            src: './assets/media/home_icon/ent_3.png',
            alt: 'image_entreprise'
        },
        {
            id: 4,
            src: './assets/media/home_icon/ent_4.png',
            alt: 'image_entreprise'
        },
        {
            id: 5,
            src: './assets/media/home_icon/ent_5.png',
            alt: 'image_entreprise'
        },
        {
            id: 6,
            src: './assets/media/home_icon/ent_6.png',
            alt: 'image_entreprise'
        },
        {
            id: 7,
            src: './assets/media/home_icon/ent_7.png',
            alt: 'image_entreprise'
        },
        {
            id: 8,
            src: './assets/media/home_icon/ent_8.jpg',
            alt: 'image_entreprise'
        },
        {
            id: 9,
            src: './assets/media/home_icon/ent_9.png',
            alt: 'image_entreprise'
        },
        {
            id: 10,
            src: './assets/media/home_icon/ent_10.png',
            alt: 'image_entreprise'
        },
        {
            id: 11,
            src: './assets/media/home_icon/ent_11.png',
            alt: 'image_entreprise'
        },
        {
            id: 12,
            src: './assets/media/home_icon/ent_12.png',
            alt: 'image_entreprise'
        }
    ])

    return (
        <div className="landing_api-weclient">
            <Fade duration={4000} left>
                <div className="landing_api-weclient-title">Découvrez nos clients sous API</div>
            </Fade>


            <div className="landing_api-weclient-content">
                <marquee direction="left" scrollamount="10">
                    {images.map((image, index) => { return <ItemPartenaire image={image} key={index} /> })}
                </marquee>
            </div>
            <a className="landing_api-weclient-contactus">CONTACTEZ NOUS</a>
        </div>
    )
}

const ItemPartenaire = ({ image }) => {
    return (
        <img className="landing-partenaire_items" src={image.src} alt={image.alt} />
    )
}

const CardWrapper = ({ children, color, hasBg = '' }) => {
    return (
        <div className={`landing_api-card-wrapper-${color}${hasBg}`}>
            {children}
        </div>
    )
}

const CardONE = () => {
    return (
        <CardWrapper color={'white'}>
            <div className="title-card-one">Notre solution a été pensée, dès sa conception, pour un usage en mode SaaS. Ceci signifie que nous gérons l’ensemble de nos clients sur la même plateforme avec le même code applicatif.</div>
            <p className='card-one-paragraph'>
                Afin de répondre à l’ensemble de nos clients, l’API de signature électronique DKBSign est très modulaire et chacun
                d’eux peut dynamiquement et de manière autonome paramétrer le comportement du service.
                L’intégration de notre API de signature électronique est un processus simple en <strong>3 étapes</strong> et <strong>2 flux principaux</strong> :
            </p>
            <img className='step-img' src="./assets/media/home_icon/stepapi.png" alt="step-api" />
            <p className='card-one-step'>
                <BsCheckCircleFill style={{ marginRight: '10px' }} className='landing-casusage__content-items-icons-check' />
                <strong>ÉTAPE 1 : </strong>Création de la demande de signature avec les documents et les données d’identification des signataires.
            </p>
            <p className='card-one-step'>
                <BsCheckCircleFill style={{ marginRight: '10px' }} className='landing-casusage__content-items-icons-check' />
                <strong>ÉTAPE 2 : </strong>Signature des documents, entièrement gérée par DKBSign sur une page multidevice et web responsive.
            </p>
            <p className='card-one-step'>
                <BsCheckCircleFill style={{ marginRight: '10px' }} className='landing-casusage__content-items-icons-check' />
                <strong>ÉTAPE 3 : </strong>Envoi et/ou récupération des documents signés.
            </p>
            <hr class="card-one-separator" />
            <p className='card-one-paragraph-bottom'>
                <strong>
                    L’API que nous mettons à disposition des développeurs est entièrement
                    documentée pour vous permettre de tester et
                    implémenter nos services de confiance en toute simplicité.
                </strong>
            </p>
            <p className='card-one-paragraph-bottom'>
                Grâce à notre offre de services professionnels,
                nous vous accompagnons dans la construction de vos workflows,
                afin que vous puissiez ajouter rapidement et simplement des fonctionnalités de signature électronique,
                de cachet électronique ou d’horodatage à vos applications existantes.
            </p>
        </CardWrapper>
    )
}

const CardTWO = () => {
    return (
        <CardWrapper hasBg={'BG'} color={'white'}>
            <div className="card-two-for-align-center">
                <div className="title-card-two">Faites le choix d’une API performante alliant sécurité et simplicité d’utilisation</div>
            </div>
        </CardWrapper>
    )
}

const CardTHREE = () => {
    return (
        <CardWrapper color={'blue'}>
            <div className="title-card-two-lg">Garantissez la conformité réglementaire de vos transactions numériques</div>
            <p className='card-two-paragraph'>
                DKBSign, Prestataire de Service de certificat électronique (PSCE)
                agréé par l’ARTCI vous apporte toutes les garanties de sécurité,
                notamment juridiques, afin d’offrir des services de confiance conférant une
                valeur probante aux documents conformément à la loi sur les transactions électroniques.
            </p>
        </CardWrapper>
    )
}

const Process = () => {
    return (
        <div className="landing_api-process">
            <Fade duration={4000} left>
                <div className="landing_api-process-title">
                    Un processus simple d’intégration
                    de nos API de signature électronique,
                    de cachet électronique et d’horodatage
                </div>
            </Fade>

            <CardONE />
            <CardTWO />
            <CardTHREE />
        </div>
    )
}

const Cachet = () => {
    return (
        <div className="landing_api-process">
            <Fade duration={4000} left>
                <div className="landing_api-process-title"> L’API de signature électronique, de cachet électronique et d’horodatage DKBSign</div>
            </Fade>

            <CardCachet />
        </div>
    )
}

const CardCachet = () => {
    return (
        <CardWrapper color={'white'} hasBg={'BGSign'}>
            <div className="title-card-one">
                Qu’il s’agisse de projets de développement d’applications ou de logiciels métier, les services de confiance sont aujourd’hui un incontournable. Ainsi, vous pouvez intégrer simplement l’API DKBSign dans votre logiciel métier :
            </div>
            <p className='card-one-step'>
                <BsCheckCircleFill style={{ marginRight: '10px' }} className='landing-casusage__content-items-icons-check' />
                <strong>CRM : </strong>intégrez l’API de signature électronique Universign et faites signer vos devis et propositions commerciales directement depuis votre CRM
            </p>
            <p className='card-one-step'>
                <BsCheckCircleFill style={{ marginRight: '10px' }} className='landing-casusage__content-items-icons-check' />
                <strong>ERP : </strong>cachetez et horodatez vos transactions pour en garantir l’intégrité et automatisez vos workflows
            </p>
            <p className='card-one-step'>
                <BsCheckCircleFill style={{ marginRight: '10px' }} className='landing-casusage__content-items-icons-check' />
                <strong>Contract Management : </strong>gérez, signez et centralisez tous vos contrats au sein d’une unique plateforme
            </p>
            <p className='card-one-step'>
                <BsCheckCircleFill style={{ marginRight: '10px' }} className='landing-casusage__content-items-icons-check' />
                <strong>SIRH : </strong>signez à distance promesses d’embauche et contrats de travail ou dématérialisez le traitement des notes de frais grâce à notre cachet électronique
            </p>

        </CardWrapper>
    )
}

const Fast = () => {
    return (
        <div className="landing_api-process">
            <Fade duration={4000} left>
                <div className="landing_api-process-title">Une API de signature électronique facile et rapide à intégrer</div>
            </Fade>

            <FastCard />
        </div>
    )
}

const FastCard = () => {
    return (
        <CardWrapper color={'green'}>
            <p className='card-two-paragraph'>
                <strong>
                    Les services web DKBsign sont performants, simples et documentés.
                    Ils vous permettent d’intégrer rapidement nos services de confiance à toutes vos applications,
                    sites web et logiciels métier de manière transparente.
                </strong>
            </p>
            <p className='card-two-paragraph'>
                Notre API a été conçue pour répondre aux besoins des développeurs et leur
                permettre de gagner en temps et en praticité. Ainsi, la plupart des projets utilisant l’API
                DKBsign sont en production seulement en quelques jours homme. Découvrez comment
                votre équipe peut implémenter l’API DKBsign en demandant notre documentation.
            </p>
        </CardWrapper>
    )
}